import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { Project } from '../../../project/models/project';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators} from "@angular/forms";
import { FormValidationService } from '../../../../shared/services/form-validation.service';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-train-type-create',
  template: require('./train-type-create.component.html'),
  styles: [require('./train-type-create.component.sass')]
})
export class TrainTypeCreateComponent implements OnInit {
  
  @ViewChild('trainTypeCreateModal') trainTypeCreateModal: ElementRef;
  
  @Input() projects: Project[];
  @Input() existingTrainTypes: string[];

  @Output() createTrainType = new EventEmitter<{
    project: Project,
    trainType: string
  }>();

  projectId: number;
  trainTypeForm: FormGroup;
  trainTypeCreateModalReference: NgbModalRef;

  constructor(
      private fb: FormBuilder,
      private modalService: NgbModal,
      public formValidation: FormValidationService
  ) {
    this.trainTypeForm = this.fb.group({
      projectId: ['', Validators.required],
      trainType: ['', Validators.required, this.isUniqueTrainType.bind(this)]
    })
  }

  ngOnInit(): void {
  }

  async showModal(projectId: string) {
    this.projectId = parseInt(projectId);
    this.trainTypeForm.reset();
    this.trainTypeForm.patchValue({
      projectId: this.projectId
    })
    this.trainTypeForm.get('projectId')?.disable()
    this.trainTypeCreateModalReference = await this.modalService.open(this.trainTypeCreateModal, {
      size: 'lg',
      backdrop: 'static'
    });
  }

  create = () => {
    const selectedProject = this.projects.find(project => project.id === this.projectId);
    if (this.trainTypeForm.valid && selectedProject) {
      this.createTrainType.emit({
        project: selectedProject,
        trainType: this.trainTypeForm.value && this.trainTypeForm.value.trainType
      });
      this.trainTypeCreateModalReference.close();
    }
  else{
      this.formValidation.validateAllFormFields(this.trainTypeForm);
    }
  }

  isUniqueTrainType(control: AbstractControl): Observable<ValidationErrors | null> {
    const value = control.value;
    if (this.existingTrainTypes && this.existingTrainTypes.find(trainType => trainType === value)) {
      return of({ duplicate: true }) 
    } 
    return of(null);
  }

}
